import { useMemo } from "react"
import { Doughnut } from "react-chartjs-2"
import { Data, TooltipModel, TooltipItem } from "../Charts"
import { fixedOptions } from "./gaugeOptions"

export type GaugeProps<TData, TLabel> = {
  data: Data<TData, TLabel>[]
  showTooltip?: boolean
  toolTipLabelFn?: (this: TooltipModel<"doughnut">, tooltipItem: TooltipItem<"doughnut">) => string[] | string
  toolTipTitleFn?: (this: TooltipModel<"doughnut">, tooltipItem: TooltipItem<"doughnut">[]) => string[] | string
  toolTipLabelColorFn?: (this: TooltipModel<"doughnut">, tooltipItem: TooltipItem<"doughnut">) => string
  height?: number
  width?: number
}

export const GaugeComponent = <TData = number, TLabel = unknown>({
  data,
  showTooltip = false,
  toolTipLabelFn,
  toolTipTitleFn,
  toolTipLabelColorFn,
  height = 320,
  width = 320,
}: GaugeProps<TData, TLabel>) => {
  const chartData = useMemo(() => {
    const colors = data.map((it) => it.color)
    return {
      datasets: [
        {
          data: data.map((it) => it.value),
          backgroundColor: colors,
          hoverBackgroundColor: colors,
        },
      ],
    }
  }, [data])
  const options = useMemo(
    () => ({
      ...fixedOptions,
      plugins: {
        ...fixedOptions.plugins,
        tooltip: {
          ...fixedOptions.plugins?.tooltip,
          enabled: showTooltip,
          callbacks: {
            ...fixedOptions.plugins?.tooltip?.callbacks,
            label: toolTipLabelFn,
            labelTextColor: toolTipLabelColorFn,
            title: toolTipTitleFn,
          },
        },
      },
    }),
    [toolTipLabelFn, toolTipTitleFn, toolTipLabelColorFn, showTooltip]
  )

  return <Doughnut options={options} data={chartData} height={height} width={width} />
}

GaugeComponent.defaultProps = {
  width: 315,
  height: 315,
  showTooltip: true,
  toolTipTitleFn: undefined,
  toolTipLabelFn: undefined,
  toolTipLabelColorFn: undefined,
}
